// App.js
import React from 'react';
import '../App.css';
import Divider from './divider';
import Lottie2 from './Lottie_Map';
import Lottie3 from './Lottie_Sell';






const MakingMoney = () =>  {
  return (

  <><div className='center' style={{ backgroundColor: '#FFF', margin: '5em 0' }}>
      <div className='flex' style={{ width: '80%', backgroundColor: 'transparent' }}>
        <div className='auto-scale-text-lg color-primary ' style={{ textAlign: 'left', width: '100%' }}>BUILD WEALTH</div>
        <div className='auto-scale-text-med color-secondary ' style={{ textAlign: 'left', width: '100%' }}>WITH PASSIVE INCOME</div>
        <Divider color='#BCD400' width='90px' margin='30' alignment='left' />

        <div className='text-content color-secondary' style={{ textAlign: 'left', width: '100%' }}>Recent studies have shown that the notion that most millionaires are born into wealth is a myth. In fact, over two-thirds of millionaires are self-made, according to a 2019 study by Wealth-X and a study by Fidelity Investments. May 8, 2023</div>


        <div className='text-content color-secondary' style={{ marginTop: '2rem', textAlign: 'left', width: '100%' }}> <span style={{ color: '#BCD400' }}>How are 90% of millionaires made?</span> By owning real estate and creating parallel streams of income with appreciable assets.</div>

        <div className='text-content color-secondary' style={{ marginTop: '2rem', textAlign: 'left', width: '100%' }}> Most real estate agents understand this fact and it is what attracted them to the business. The successful agents have done this instinctively over time by parlaying their earnings into appreciable assets. Finally, the game has changed. Our agents can start building a parallel income stream on day one of their career.</div>

      </div>
    </div>


    <div className='center' style={{ backgroundColor:'transparent'}}>
          <div className='center_8-10' style={{ paddingTop: '5em' }}>
          
              <div className='flex'
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>

                
                <div className='flex-row'>
                    <div className="flex-box-50 center"  style={{ backgroundColor: '#BCD400', padding: '3rem' }}>

                      <div className='auto-scale-text-lg color-white ' style={{ textAlign: 'left', width: '100%' }}>STEP 1</div>
                      <div className='auto-scale-text-med color-white ' style={{ textAlign: 'left', width: '100%' }}>SELL REAL ESTATE</div>
                      <Divider color='white' width='90px' margin='30' alignment='left' />

                      <div className='text-content color-white' style={{ textAlign: 'left', width: '100%' }}>The agent keeps 80% (or $60,000) of the first $75,000 in gross commissions earned annually. Agent keeps 100% of gross commissions earned beyond $75,000.</div>
                      <div>
                      <Lottie3 />
                      </div>
                    </div>

                      
                    <div className="flex-box-50 center"  style={{ backgroundColor: '#333', padding: '3rem'  }}>
                    <div className='auto-scale-text-lg color-white ' style={{ textAlign: 'left', width: '100%' }}>STEP 2</div>
                      <div className='auto-scale-text-med color-white ' style={{ textAlign: 'left', width: '100%' }}>ONBOARD NEW AGENTS</div>
                      <Divider color='white' width='90px' margin='30' alignment='left' />

                      <div className='text-content color-white' style={{ textAlign: 'left', width: '100%' }}>Start building your team of agents from around the country and you could earn profit share checks from Day 1.</div>
                      <div>
                      <Lottie2 />
                      </div>
                    </div>
                </div>
                </div>


              </div>
            </div>







        <div>

        </div>

      </>


  );
}

export default MakingMoney;